exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.toLogin[data-v-59f359c4]{\n  text-align: center;\n}\n", ""]);

// exports
